import React from 'react'
import { Button, Dropdown, Menu } from 'antd'
import { DataTable } from './DataTable'
import { YhBox } from '@/components/YhBox'
import { DescriptionColorEnum, IDescription } from '@/components/YhBox/Types'
import useNavModel from '@/model/navModel'
import { globalPrompt } from '@/components/message'
import { YhAuth } from '@/components/auth/YhAuth'
import { useAssetsReturnDetailsModel } from './details/assetsReturnDetailsModel'
import { useAssetsReturnModel } from '../assetsReturnModel'
import { ResourceAuthEnum } from '@/types/AppResourceAuthEnum'
import { PlusOutlined } from '@ant-design/icons'

export const DataBox = () => {
    const { selectedRowKeys, statistics, exportData,setPrint } = useAssetsReturnModel()
    const { resetEditCatch } = useAssetsReturnDetailsModel()
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => [])

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt('message', { text: '请选择单条数据进行编辑，点击鼠标右键可一键选中哦！', type: 'warning' })
            return
        }
        let AssetsReturnEditKey = '2-3-2'
        let isFindNav = findNav(AssetsReturnEditKey)
        if (!isFindNav) {
            addNav(AssetsReturnEditKey, { id: selectedRowKeys[0] as string, mode: 'edit' })
            resetEditCatch()
        } else {
            globalPrompt('modal', {
                title: '物资归还跳转详情',
                type: 'warning',
                text: '您还有物资归还详情未保存，是否跳转',
                okText: '跳转未保存页',
                onOk: () => selectNav(isFindNav ? isFindNav.id : ''),
                cancelText: '打开新页签',
                onCancel: () => {
                    switchNavState(AssetsReturnEditKey, { id: selectedRowKeys[0] as string, mode: 'edit' })
                    resetEditCatch()
                },
            })
        }
    }

    const action = (
        <>
        <YhAuth resCode={ResourceAuthEnum.ASSETS_S_R_AD}>
            <Button className="mr-5" type="link" shape="round" onClick={() => addNav('2-3-1', { id: '', mode: 'add' })}>
            <PlusOutlined />
                归还
            </Button>
            </YhAuth>
            {/* <Button className="mr-5" type="link" shape="round" onClick={onEdit}>
                更新
            </Button> */}
            <YhAuth resCode={ResourceAuthEnum.ASSETS_S_R_PRINT}>
            <Button className="mr-5" type="link" shape="round" disabled={selectedRowKeys.length !== 1}
                onClick={() => setPrint(true)}>
                打印
            </Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.ASSETS_S_R_EX}>
            <Button className="mr-5" type="link" shape="round" onClick={() => exportData()}>
                导出
            </Button>
            </YhAuth>
            <div style={{ fontSize: '17px', fontWeight: 'bolder', float: 'right' }}>
                <span>
                    归还数量：<span style={{ color: 'green' }}>{statistics?.totalNum}</span>
                </span>
                <span style={{ marginLeft: '20px' }}>
                    归还金额：<span style={{ color: 'red' }}>{statistics?.totalAmount}</span>
                </span>
            </div>
        </>
    )

    return (
        <YhBox action={action}>
            <DataTable />
        </YhBox>
    )
}
